import React from "react";
import { Segmented } from "antd";

import { ANCESTRY_MAP_VIEW_LABEL, ANCESTRY_MODE_SWITCH_LABEL, EXPLORER_TITLE } from "./ecologyTypes";

export type AncestryView = "ancestry" | "explorer";

export interface AncestryViewTabsProps {
	view: AncestryView;
	onChange: (view: AncestryView) => void;
}

const AncestryViewTabs: React.FC<AncestryViewTabsProps> = ({ view, onChange }) => (
	<div className="ancestry-view-tabs" data-testid="ancestry-view-tabs">
		<Segmented
			size="small"
			value={view}
			onChange={(next) => onChange(next as AncestryView)}
			aria-label={ANCESTRY_MODE_SWITCH_LABEL}
			options={[
				{ value: "ancestry", label: <span data-testid="ancestry-view-map">{ANCESTRY_MAP_VIEW_LABEL}</span> },
				{ value: "explorer", label: <span data-testid="ancestry-view-explorer">{EXPLORER_TITLE}</span> },
			]}
		/>
	</div>
);

export default AncestryViewTabs;
